@if (stepChanged$ | async) {
  <div class="category">
    @for (step of steps; track step; let index = $index) {
      @if (groupedData[step]?.length) {
        <div
          [ngClass]="step === category ? 'current' : ''"
          #selectStep
          class="steps"
        >
          <ng-container>
            <div
              [ngClass]="
                !categorizedData[step]?.previousStepCompleted ? 'disabled' : ''
              "
              class="step"
              (click)="setStep(step, index)"
            >
              <step-logo
                [step]="step"
                [category]="category"
                [categorizedData]="categorizedData"
              ></step-logo>
              <div class="step__title">
                <div class="step__title__name">
                  {{ step }}
                </div>
                @if (step !== 'Signature') {
                  <div class="step__title__questions">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                    >
                      <path
                        d="M13 7.16669C13.0023 8.0466 12.7967 8.91461 12.4 9.70002C11.9296 10.6412 11.2065 11.4328 10.3116 11.9862C9.41677 12.5396 8.3855 12.8329 7.33333 12.8334C6.45342 12.8356 5.58541 12.6301 4.8 12.2334L1 13.5L2.26667 9.70002C1.86995 8.91461 1.66437 8.0466 1.66667 7.16669C1.66707 6.11452 1.96041 5.08325 2.51381 4.18839C3.06722 3.29352 3.85884 2.5704 4.8 2.10002C5.58541 1.70331 6.45342 1.49772 7.33333 1.50002H7.66667C9.05623 1.57668 10.3687 2.16319 11.3528 3.14726C12.3368 4.13132 12.9233 5.44379 13 6.83335V7.16669Z"
                        stroke="#0066FF"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span> {{ groupedData[step]?.length }} Questions </span>
                  </div>
                }
              </div>
            </div>
            @if (isConsultant && step != 'Composition du crédit') {
              @if (step !== 'Signature') {
                <div class="menu-list">
                  <menu-list
                    [step]="step"
                    [disabled]="
                      categorizedData[step]?.allPreviousStepsCompleted
                    "
                  ></menu-list>
                </div>
              }
            }
            @if (step !== 'Signature') {
              @for (i of [1, 2, 3, 4]; track i) {
                <div class="numbers">
                  <div
                    class="number"
                    [ngClass]="
                      categorizedData[step]?.isComplete ||
                      (step === category &&
                        categorizedData[step]?.data?.length == 1) ||
                      (step === category && i <= stepIndex)
                        ? 'green-svg-number'
                        : 'empty-svg-number'
                    "
                  ></div>
                </div>
              }
            }
          </ng-container>
        </div>
      }
    }
  </div>
}
<ng-template #alternateIcon>
  <mat-icon class="red">quiz</mat-icon>
</ng-template>
